<template>
    <div style="height:100%;">
        <div class="header">
            <div class="clock-left">
                <clock style="color: #53d8ff; font-size: 22px;"></clock>
            </div>
            <div class="header-title">
                <!-- <h4>智慧渔业可视化管控平台</h4> -->
                <h4>智慧食用菌数据可视化平台</h4>
            </div>

            <div style="height: 120px; display: flex; ">
                <!-- <div v-if="$route.name == 'page2'">
                    <el-button @click="handAdd" style="margin-top: 10px; margin-right: auto;">添加数据</el-button>
                </div> -->
                <div class="fishpond" style="width: 400px; height: 40px; display: flex; align-items: center; gap: 8px;">
                    <!-- page1 顶部选择器，放在退出登录左边 -->
                    <template v-if="$route.name === 'page1'">
                        <template v-if="isSuperAdmin">
                            <el-select v-model="selectedCompanyId" placeholder="选择公司" size="small" style="width: 150px;"
                                @change="onCompanyChange">
                                <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                            <el-select v-model="selectedGreenhouseId" placeholder="选择大棚" size="small" style="width: 140px;"
                                :disabled="greenhouseLoading" @change="onGreenhouseChange">
                                <el-option v-for="item in greenhouseList" :key="item.id" :label="item.name || item.label" :value="item.id" />
                            </el-select>
                        </template>
                        <template v-else>
                            <el-select v-model="selectedGreenhouseId" placeholder="选择大棚" size="small" style="width: 200px;"
                                :disabled="greenhouseLoading" @change="onGreenhouseChange">
                                <el-option v-for="item in greenhouseList" :key="item.id" :label="item.name || item.label" :value="item.id" />
                            </el-select>
                        </template>
                    </template>
                    <div style="flex:1;"></div>
                    <div class="dropdown">
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <span @click="logout">退出登录</span></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="水质信息" :visible.sync="dialogFormVisible1" width="30%">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="亚硝酸盐">
                    <el-input v-model="form.nitr"></el-input>
                </el-form-item>
                <el-form-item label="氨氮">
                    <el-input v-model="form.an"></el-input>
                </el-form-item>
                <el-form-item label="所属池塘">
                    <el-select v-model="form.pondsid" clearable placeholder="请选择要添加数据的池塘">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="测量时间">
                    <el-date-picker v-model="form.date" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save">确定</el-button>
                    <el-button @click='shutDown'>取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <div class="page" style="flex: 1; overflow: auto;">
            <router-view v-if="flag" :value="value" :selectRangeDate='selectRangeDate'></router-view>
        </div>

    </div>
</template>

<script>
    const clock = () => import('./components/clock');
    export default {
        name: '',
        components: {
            clock
        },
        data() {
            return {
                activeName: 'month',// 默认显示近一月
                modal: false,
                flag: true,
                selectRangeDate: [],
                optionEnd: {},
                resizeFn: null,
                options: [],
                pondid: null,
                value: '',
                // user: {},
                form: {},
                time: '',
                dialogFormVisible1: false,
                role: (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}).role,
                user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
                userId:(localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}).id,
                isSuperAdmin: false,
                selectedCompanyId: null,
                selectedGreenhouseId: null,
                companyList: [],
                greenhouseList: [],
                greenhouseLoading: false,
                allPages: [
                ],
                visiblePages: [
                ], // 用户选择后展示的页面
            }
        },
        watch: {
            '$route.name'(val) {
                if (val === 'page1') {
                    this.initSelection();
                }
            },
            pondid(/*pondid*/) {
                this.getPonds()
            }
        },
        mounted() {
            this.fetchAllPages();
            this.fetchVisiblePages();
            this.getPonds();
            if (this.$route.name === 'page1') {
                this.initSelection();
            }
        },
        created() {

        },
        methods: {
            async initSelection() {
                // 根据 role 字段判断是否为超级管理员
                this.isSuperAdmin = this.user && this.user.role === '超级管理员';
                if (this.isSuperAdmin) {
                    await this.loadCompanies();
                    if (!this.selectedCompanyId && this.companyList.length > 0) {
                        this.selectedCompanyId = this.companyList[0].id;
                    }
                } else {
                    this.selectedCompanyId = this.user ? this.user.companyid : null;
                }
                await this.loadGreenhouses(this.selectedCompanyId);
                if (!this.selectedGreenhouseId && this.greenhouseList.length > 0) {
                    this.selectedGreenhouseId = this.greenhouseList[0].id;
                }
                // 确保数据加载完成后才广播
                this.$nextTick(() => {
                    this.broadcastSelection();
                });
            },
            async loadCompanies() {
                try {
                    const res = await this.request.get('/api/companies/');
                    const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
                    this.companyList = list;
                } catch (e) {
                    this.companyList = [];
                }
            },
            async loadGreenhouses(companyId) {
                this.greenhouseLoading = true;
                try {
                    if (!companyId) {
                        this.greenhouseList = [];
                        return;
                    }
                    const res = await this.request.get('/api/greenhouses/list', { params: { companyId } });
                    const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
                    this.greenhouseList = list;
                } catch (e) {
                    this.greenhouseList = [];
                } finally {
                    this.greenhouseLoading = false;
                }
            },
            onCompanyChange(id) {
                this.selectedCompanyId = id;
                this.selectedGreenhouseId = null;
                this.loadGreenhouses(id).then(() => {
                    if (!this.selectedGreenhouseId && this.greenhouseList.length > 0) {
                        this.selectedGreenhouseId = this.greenhouseList[0].id;
                    }
                    // 确保数据加载完成后才广播
                    this.$nextTick(() => {
                        this.broadcastSelection();
                    });
                });
            },
            onGreenhouseChange(id) {
                this.selectedGreenhouseId = id;
                this.broadcastSelection();
            },
            broadcastSelection() {
                // 通知 page1 组件
                window.dispatchEvent(new CustomEvent('page1-selection', {
                    detail: {
                        companyId: this.selectedCompanyId,
                        greenhouseId: this.selectedGreenhouseId
                    }
                }));
                // 持久化
                if (this.selectedCompanyId != null) {
                    localStorage.setItem('page1_companyId', this.selectedCompanyId);
                }
                if (this.selectedGreenhouseId != null) {
                    localStorage.setItem('page1_greenhouseId', this.selectedGreenhouseId);
                }
            },
            fetchAllPages() {
                // 菜单接口（/menu/findAll、/userMenu/*）在当前后端未提供。
                // 这里改为前端静态菜单：根据角色控制可见页面，避免请求 404 影响页面初始化。
                const role = (this.user && this.user.role) || '';
                const pages = [
                    { name: 'page1', label: '综合大屏' },
                ];

                this.allPages = pages;

                // 权限控制：
                // - 超级管理员：全部可见
                // - 管理员：全部可见（如需限制可在这里删减）
                // - 用户：默认仅显示 page1（可按需放开）
                if (role === '用户') {
                    this.visiblePages = pages.filter(p => p.name === 'page1');
                } else {
                    this.visiblePages = pages;
                }
            },
            fetchVisiblePages() {
                // 兼容旧调用点：visiblePages 已在 fetchAllPages 中处理
            },
            pickStartDate(date) { // 选择开始时间的回调
                this.startTime = date;
                this.optionEnd = {
                    disabledDate(d) { // 禁止选择开始时间之前的日期
                        return d && d.valueOf() < new Date(date).valueOf() - 86400000;
                    }
                }
            },
            pickEndDate(date) { // 选择结束时间的回调
                this.endTime = date;
            },
            getMonthBetween(start, end) {  // 获取开始时间和结束时间之内的所有月份
                this.selectRangeDate = [];
                let s = start.split("-");  // 字符串装换数组
                let e = end.split("-");
                let date = new Date();
                let min = date.setFullYear(s[0], s[1] - 1); // 设置最小时间
                let max = date.setFullYear(e[0], e[1] - 1); // 设置最大时间
                let curr = min;
                while (curr <= max) {  // 循环添加月份
                    var month = curr.getMonth();
                    var arr = [curr.getFullYear(), month + 1];
                    this.selectRangeDate.push(arr);
                    curr.setMonth(month + 1);
                }
            },
            getDays(day) {// 获取天数
                let arr = [];
                for (let i = -day; i < 0; i++) { // 循环添加天数
                    let today = new Date();// 获取今天
                    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * i;
                    today.setTime(targetday_milliseconds); //设置i天前的时间
                    let tYear = today.getFullYear();
                    let tMonth = today.getMonth();
                    let tDate = today.getDate();
                    let date = [tYear, tMonth + 1, tDate];
                    arr.push(date);
                }
                return arr
            },
            handleSelect(name) {
                switch (name) {
                    case 'day':

                        break;
                    case 'week':

                        this.selectRangeDate = this.getDays(7);// 获取近一周的天数
                        this.flag = true;

                        break;
                    case 'month':
                        this.selectRangeDate = this.getDays(30);// 获取近一个月的天数
                        this.flag = true;
                        break;
                    case 'filter':
                        this.modal = true;
                        break;
                    default:
                        break;
                }

            },
            logout() {
                localStorage.removeItem("user")
                this.$message.success("退出用户成功")
                this.$router.push("/backstagelogin")
            },
            getPonds() {
                // 从sensor表获取不同的sid值来生成大棚选项
                this.request.get('/api/sensors', {
                    params: {}
                }).then(res => {
                    // 获取所有不同的sid值
                    const sidSet = new Set();
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            if (item.sid) {
                                sidSet.add(item.sid);
                            }
                        });
                    }
                    
                    // 将sid转换为选项
                    const sidArray = Array.from(sidSet).sort((a, b) => a - b);
                    this.options = sidArray.map(sid => {
                        // 根据sid生成名称，1对应"一号棚"，其他对应"X号棚"
                        let name = sid === 1 ? '一号棚' : `${sid}号棚`;
                            return {
                            value: sid,
                            label: name
                        };
                    });
                    
                    // 如果没有数据，使用默认选项
                    if (this.options.length === 0) {
                        this.options = [
                            { value: 1, label: '一号棚' },
                            { value: 2, label: '二号棚' }
                        ];
                    }
                    
                    if (this.options.length > 0) {
                        this.value = this.options[0].value
                    }
                }).catch(error => {
                    console.log(error);
                    // 如果请求失败，使用默认选项
                    this.options = [
                        { value: 1, label: '一号棚' },
                        { value: 2, label: '二号棚' }
                    ];
                    if (this.options.length > 0) {
                        this.value = this.options[0].value
                    }
                })
            },
            // selectPonds(value) {
            // },
            handAdd() {
                this.dialogFormVisible1 = true;
                this.form = {};
                this.time = '';
            },
            save() { // 新增或更新
                this.request.post('/api/artWaterQualifyData/', this.form).then(res => {
                    if (res) {
                        this.$message.success('保存成功')
                        this.dialogFormVisible = false
                        this.$router.go(0);
                    } else {
                        this.$message.success('保存失败')
                    }
                })
            },
            shutDown() {
                this.form = {}
                this.dialogFormVisible1 = false
            }
        }
    }
</script>

<style lang="less">
    .ivu-modal {
        .ivu-modal-content {
            background: #071332;

            .ivu-modal-header {
                border-bottom: 1px solid #1a3c58;

                .ivu-modal-header-inner {
                    color: #75deef;
                }
            }

            .ivu-modal-body {
                text-align: center;

                .ivu-icon {
                    color: #75deef
                }

                .ivu-modal-confirm-body {
                    padding-left: 0;
                    color: #75deef
                }

                .ivu-input {
                    background-color: rgba(0, 0, 0, 0);
                    border: 1px solid #1a3c58;
                    color: #75deef;

                    &::-webkit-input-placeholder {
                        /* WebKit, Blink, Edge */
                        color: #75deef;
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: #75deef;
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: #75deef;
                    }

                    &::-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: #75deef;
                    }
                }

                .ivu-picker-panel-body {
                    background: #071332;

                    .ivu-date-picker-header {
                        color: #75deef;
                        border-bottom: 1px solid #1a3c58
                    }

                    .ivu-date-picker-cells-cell {
                        color: #75deef;

                        &:hover em {
                            background: #1a3c58;
                        }
                    }

                    .ivu-date-picker-cells-cell-disabled {
                        background: rgba(0, 0, 0, 0);
                        color: #eee
                    }

                    .ivu-date-picker-cells-focused em {
                        box-shadow: 0 0 0 1px #1a3c58 inset;

                        &::after {
                            background: #1a3c58;
                        }
                    }
                }
            }

            .ivu-modal-footer {
                border-top: 1px solid #1a3c58;

                .ivu-btn-primary {
                    color: #75deef;
                    background: #1a3c58;
                }

                .ivu-btn-text {
                    color: #ddd;

                    &:hover {
                        color: #75deef;
                        background: #1a3c58;
                    }
                }
            }
        }
    }

    .header {
        height: 80px;
        background: #03044A;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: relative;


        &-title {
            color: #fff;
            font-size: 30px;
            letter-spacing: 15px;
            margin-top: 30px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            display: flex;
            align-items: center;
            gap: 20px;

            .clock-wrapper {
                display: flex;
                align-items: center;
            }

            h4 {
                margin: 0;
            }
        }

        .fishpond {
            margin-right: 40px;
            margin-top: 10px;
            align-items: center;
            flex: 1;
            display: flex;
        }

        .dropdown {
            width: 20px;

            margin-left: auto;

            .el-dropdown-link {
                color: #ffffff;
                font-size: 15px;
            }
        }

        .selectRange {
            height: 100%;

            .ivu-menu-horizontal {
                background: rgba(255, 255, 255, 0);

                &::after {
                    height: 0;
                }

                .ivu-menu-item-active {
                    border-bottom: 2px solid #264e5e;

                }

                .ivu-menu-item,
                .ivu-menu-submenu {
                    color: #fff;

                    &:hover {
                        border-bottom: 2px solid #264e5e;
                    }
                }

                .ivu-select-dropdown {
                    background: #09102E;

                    .ivu-menu-item {
                        color: #75deef;

                        &:hover {

                            border-bottom: 2px solid #264e5e;
                            background-color: rgba(255, 255, 255, 0);
                        }
                    }
                }

                .ivu-menu-submenu-title {
                    i {
                        margin-right: 0;
                    }

                    .ivu-icon-ios-arrow-down {
                        display: none;
                    }
                }
            }
        }
    }

    .page {
        height: calc(100% - 80px)
    }
</style>